import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01453fe2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=01453fe2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01453fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01453fe2')) {
      api.createRecord('01453fe2', component.options)
    } else {
      api.reload('01453fe2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=01453fe2&scoped=true", function () {
      api.rerender('01453fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CouponProductsImport/index.vue"
export default component.exports